<template>
  <div class="top-header" :class="{ 'top-header-yellow': yellow }">
    <div class="top-header-burger"
      @click="openMenu">
      <icon name="burger-icon" /></div>

    <div class="top-header-logo">
      <router-link to="/home-2">
        <icon name="nerdhire-logo" /></router-link>
      </div>

    <nav class="top-header-nav m200">
      <router-link to="/for-students-2">FOR STUDENTS</router-link>
      <router-link to="/for-nerds">FOR NERDS</router-link>
      <!-- <router-link to="/pricing">PRICING</router-link> -->
      <router-link to="/how-it-works">HOW IT WORKS</router-link>
    </nav>

    <!-- <router-link class="top-header-pay-btn m200"
      to="/pay">PAY</router-link> -->

    <div class="top-header-buttons">
      <router-link to="/">Chat With Us</router-link>
      <router-link to="tel:+1-513-817-3726">Call Us</router-link>
      <router-link to="/" class="quote_link">Get Quote Now!</router-link>
    </div>
    <!-- <div class="top-header-off">
      <h3 class="kanit800">20% OFF</h3>
      <p class="proxima600">First Order</p>
    </div> -->
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import EventBus from '@/utils/event-bus'
export default {
  components: {
    Icon
  },
  props: {
    yellow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openMenu () {
      EventBus.$emit('OPEN_MENU_POPUP')
    }
  }
}
</script>

<style lang="scss">
  @import '~@/styles/media';

  .top-header {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    padding: 20px;

    &-yellow {
      // background-color: var(--bg-yellow) !important;
      background-color: #fdc719 !important;
    }

    &-logo {
      margin-left: 20px;

      svg {
        width: 45px;
        height: 31px;
      }
    }

    &-nav {
      display: none;

      a {
        position: relative;
        margin: 0 20px;
        color: var(--primary-black);
        text-decoration: none;
        padding-bottom: 10px;
        border-color: transparent;
        transition: border-color .25s ease-out;
        font-weight: 400;
        font-family: 'Kanit';

        &:after {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          height: 4px;
          background: var(--fb-blue);
          content: '';
          opacity: 0;
          transition: opacity 0.3s, transform 0.3s;
          transform: translateY(10px);
        }

        &:hover {
          &:after {
            opacity: 1;
            transform: translateY(0px);
          }
          // border-bottom: 4px solid var(--fb-blue);
        }
      }

      .router-link-exact-active {
        &:after {
          position: absolute;
          top: calc( 100% - 3px );
          left: 0;
          width: 100%;
          height: 4px;
          background: var(--fb-blue);
          content: '';
          opacity: 1;
          transition: opacity 0.3s, transform 0.3s;
          transform: translateY(0);
        }
      }
    }

    &-buttons {

      a {
        border: 2px solid #0295e3;
        height: 35px;
        line-height: 35px;
        display: inline-block;
        padding: 0 25px;
        border-radius: 6px;
        margin-left: 15px;
        background: #fdc719;
        box-shadow: 6px 6px 0 #d3ab0d;
        text-decoration: none;
        font-family: 'ProximaNova-Bold';
        letter-spacing: -0.5px;
        color: #000;

        &:hover {
          background-color: var(--fb-blue);
          border-color: var(--fb-blue);
          color: var(--primary-white);
        }
        &.quote_link {
          background-color: var(--primary-green);
          border: 2px solid var(--primary-green);
          color: var(--primary-white);
          &:hover {
            background-color: var(--primary-green-hover);
            border-color: var(--primary-green-hover);
          }
        }
      }
      @media #{$mobile} {
        display: none;
      }
    }

    &-off {
        background-image: url('~@/assets/images/star.png');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: contain;
        padding: 4px 0 0 46px;
      h3 {
        font-size: 23px !important;
        line-height: 22px;
        margin-bottom: 0 !important;
      }
      p {
        font-size: 13px;
        line-height: 12px;
        margin: 0;
        text-transform: uppercase;
      }
      @media #{$desktop} {
        display: none;
      }
      @media #{$sxs} {
        h3 {
          font-size: 18px !important;
        }
        p {
          font-size: 10px;
          line-height: 16px;
        }
      }
    }

    &-pay-btn {
      background-color: var(--pay-btn-blue);
      border-radius: 4px;
      width: 77px;
      height: 32px;
      font-size: 14px;
      line-height: 32px;
      text-align: center;
      display: inline-block;
      box-sizing: border-box;
      color: var(--primary-white);
      transition: background-color .2s ease-out;
      text-decoration: none;

      &:hover {
        border: none;
        background-color: var(--fb-blue-hover);
      }
    }

    @media #{$desktop} {
      font-size: 18px;
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      // max-width: 87%;
      // margin: 0 auto;
      padding: 10px 40px;
      background-color: transparent;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      box-sizing: border-box;
      background-color: #fdc719;
      z-index: 10;

      &-burger {
        display: none;
      }

      &-logo {
        svg {
          width: 150px;
          height: 55px;
        }
      }

      &-nav {
        display: block;
        justify-self: end;
        margin-right: 20px;
      }

      &-pay-btn {
        width: 94px;
        height: 40px;
        font-size: 17px;
        line-height: 40px;
      }
    }
    @media (min-width: 1200px) and (max-width: 1299px) {
      .top-header-buttons a {
        font-size: 15px;
      }
    }
    @media (min-width: 1000px) and (max-width: 1199px) {
      .top-header-logo {
        margin-left: 0;
      }
      .top-header-nav {
        margin-right: 0px;

        a {
          margin: 0 10px;
          font-size: 15px;
        }
      }
      .top-header-buttons a {
        font-size: 15px;
        padding: 0 15px;
      }
    }
  }
</style>
